import React from 'react'
import { settingsConfig } from 'src/assets/SettingsConfig'
import SettingsList from 'src/components/settings/SettingsList'

const index = ({}) => {
  if (!Boolean(settingsConfig?.length)) return <></>
  return (
    <div className='p-8 w-full'>
      <h1 className='w-full text-xl font-semibold text-carbon'>Settings</h1>
      <div className='mt-4'>
        <SettingsList />
      </div>
    </div>
  )
}

export default index
